export interface SupportSession {
  id: string;
  userId: string;
  userEmail: string;
  expiresAt: string;
  readOnly: true;
}
interface StoredSupport {
  token: string;
  session: SupportSession;
}
const KEY = "customy.operator-support.v1";
const CHANNEL = "customy.operator-support";

export function readOperatorSupport(): StoredSupport | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) || "null");
    return value &&
      /^css_[a-f0-9]{64}$/.test(value.token) &&
      value.session?.id &&
      value.session?.userId
      ? value
      : null;
  } catch {
    return null;
  }
}
export function storeOperatorSupport(value: StoredSupport) {
  sessionStorage.setItem(KEY, JSON.stringify(value));
}
export function clearOperatorSupport(broadcast = true) {
  const current = readOperatorSupport();
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* no persisted context */
  }
  if (current && broadcast && typeof BroadcastChannel !== "undefined") {
    const channel = new BroadcastChannel(CHANNEL);
    channel.postMessage({ ended: current.session.id });
    channel.close();
  }
}
export function returnFromOperatorSupport() {
  const current = readOperatorSupport();
  clearOperatorSupport();
  if (current) window.location.assign(`/admin/users/${encodeURIComponent(current.session.userId)}`);
}
export function watchOperatorSupportEnd() {
  if (typeof BroadcastChannel === "undefined") return () => {};
  const channel = new BroadcastChannel(CHANNEL);
  channel.onmessage = (event) => {
    const current = readOperatorSupport();
    if (current && event.data?.ended === current.session.id) {
      clearOperatorSupport(false);
      window.location.assign(`/admin/users/${encodeURIComponent(current.session.userId)}`);
    }
  };
  return () => channel.close();
}
